import { render } from "./CreatePermission.vue?vue&type=template&id=7ea08a26"
import script from "./CreatePermission.vue?vue&type=script&lang=js"
export * from "./CreatePermission.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__